module.exports = __webpack_public_path__ + "static/media/ic_product_inactive.c0f494f2.svg";